export function buildClassName(...args: any[]) {
  const className = args.filter((arg) => !!arg).join(" ");
  if (className === "") {
    return undefined;
  }
  return className;
}
